import { connect } from '@atlassian/jira-react-redux';
import { hasRules } from '../../state/selectors/rulesets';
import { isRunAsUserInvalid } from '../../state/selectors/run-as-user';
import { hasGlobalError } from '../../state/selectors/summary';
import type { State } from '../../state/types';
import AddRule from './add-rule';
import EmptyView from './empty-view';
import SummaryHeader from './header';
import MisconfiguredMessage from './misconfigured-message';
import PageError from './page-error';
import RuleLimitMessage from './rule-limit-message';
import RuleList from './rule-list';
import Layout from './view';

const mapStateToProps = (state: State) => ({
	HeaderComponent: SummaryHeader,
	RuleListComponent: RuleList,
	EmptyViewComponent: EmptyView,
	AddRuleComponent: AddRule,
	PageErrorComponent: PageError,
	MisconfiguredMessageComponent: MisconfiguredMessage,
	RuleLimitMessageComponent: RuleLimitMessage,
	hasRules: hasRules(state),
	isRunAsUserMisconfigured: isRunAsUserInvalid(state),
	hasGlobalError: hasGlobalError(state),
});

export default connect(mapStateToProps, {})(Layout);
